import * as Yup from 'yup';
import { t } from 'src/lib/language';
import { idFieldRequired } from 'src/lib/ValidatorHelper';

const SubscriptionValidator = (lang: string, hasInvoice = false) => Yup.object().shape({
  title: Yup.string()
    .max(150, t(lang, 'validations.invoice.field_maximum', { max: 150 }))
    .required(t(lang, 'validations.contact.field_required')),
  frequency: Yup.string().nullable(),
  start_date: Yup.string().required(t(lang, 'validations.contact.field_required')),
  end_date: Yup.string().nullable(),
  contact_id: Yup.number()
    .min(1, t(lang, 'validations.contact.field_required'))
    .required(t(lang, 'validations.contact.field_required')),
  department_id: hasInvoice
    ? idFieldRequired().required(t(lang, 'validations.invoice.field_required'))
    : Yup.mixed().notRequired(),
  account_id: hasInvoice
    ? idFieldRequired().required(t(lang, 'validations.invoice.field_required'))
    : Yup.mixed().notRequired(),
  program_id: hasInvoice
    ? idFieldRequired().required(t(lang, 'validations.invoice.field_required'))
    : Yup.mixed().notRequired(),
});

export default SubscriptionValidator;
